module.exports = __webpack_public_path__ + "img/freedom_icon.f9245b80.svg";